import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { LogicalDeviceDetailsTypes } from "@sportal/api";

import { ellipsifyUUID } from "../../helpers/devices.helpers";
import { Icon } from "../icon/Icon";
import { getRoamingDetailsByIdentifier } from "../../store/devices/logicalDevices";
import { ProtectionStatus } from "../../pages/spson/roamingTables/ProtectionStatus";

import "./DeviceWithType.scss";

const DeviceIcon = ({ type }) => {
  let icon;

  switch (type) {
    case LogicalDeviceDetailsTypes.Line: {
      icon = "mobile-android-alt";
      break;
    }
    case LogicalDeviceDetailsTypes.Roaming: {
      icon = "satellite-dish";
      break;
    }
    default: {
      icon = "wifi";
    }
  }

  return <Icon icon={`fa-solid fa-${icon}`} />;
};

const RoamingDeviceWithProtectionStatus = ({ identifier }) => {
  const details = useSelector(
    (state) => getRoamingDetailsByIdentifier(state, identifier),
    _.isEqual
  );

  return (
    <Fragment>
      <ProtectionStatus status={details.protectionStatus} showTooltip={true} />
      <span className="device-identifier">{ellipsifyUUID(identifier)}</span>
    </Fragment>
  );
};

function renderContent(type, identifier) {
  switch (type) {
    case LogicalDeviceDetailsTypes.Roaming: {
      return <RoamingDeviceWithProtectionStatus identifier={identifier} />;
    }
    case LogicalDeviceDetailsTypes.Line:
    case LogicalDeviceDetailsTypes.Mac:
    default: {
      return (
        <Fragment>
          <DeviceIcon type={type} />
          <span>{identifier}</span>
        </Fragment>
      );
    }
  }
}

export const DeviceWithType = ({ identifier, type }) => {
  return (
    <div className={"device-with-type"}>{renderContent(type, identifier)}</div>
  );
};

DeviceWithType.propTypes = {
  identifier: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    LogicalDeviceDetailsTypes.Line,
    LogicalDeviceDetailsTypes.Mac,
    LogicalDeviceDetailsTypes.Roaming,
  ]).isRequired,
};
